import { useMutation } from '@apollo/client';

import { ConvertQuoteToInvoiceInput } from '__generated__/GQL';

import { ConvertQuoteToInvoiceDocument } from './graphql/convertQuoteToInvoice.gql';

export const useConvertQuoteToInvoice = (input: ConvertQuoteToInvoiceInput) => {
  return useMutation(ConvertQuoteToInvoiceDocument, {
    awaitRefetchQueries: true,
    variables: { input },
  });
};
